import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { login, requestWhatsAppCode } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  
  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      setError('');
      
      // Login the user
      const response = await login({
        email: data.email,
        password: data.password
      });
      
      // Request WhatsApp verification code
      await requestWhatsAppCode();
      
      // Navigate to WhatsApp verification page
      navigate('/verify-whatsapp');
    } catch (err) {
      if (err.response?.data?.error_message) {
        setError(err.response.data.error_message);
      } else if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else {
        setError('שגיאה בהתחברות. אנא נסה שנית.');
      }
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-3xl font-extrabold text-gray-900">התחברות</h1>
          <p className="mt-2 text-sm text-gray-600">
            או{' '}
            <Link to="/register" className="font-medium text-blue-600 hover:text-blue-500">
              הרשמה למערכת
            </Link>
          </p>
        </div>
        
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
            <span className="block sm:inline">{error}</span>
          </div>
        )}
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
          <div>
            <label htmlFor="email" className="form-label">אימייל</label>
            <input
              id="email"
              type="email"
              {...register('email', { 
                required: 'אימייל הוא שדה חובה',
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: 'אנא הזן כתובת אימייל תקינה'
                }
              })}
              className="form-input"
              placeholder="הזן את כתובת האימייל שלך"
              dir="ltr"
            />
            {errors.email && (
              <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>
            )}
          </div>
          
          <div>
            <div className="flex items-center justify-between">
              <label htmlFor="password" className="form-label">סיסמה</label>
              <Link to="/reset-password" className="text-sm font-medium text-blue-600 hover:text-blue-500">
                שכחת סיסמה?
              </Link>
            </div>
            <input
              id="password"
              type="password"
              {...register('password', { 
                required: 'סיסמה היא שדה חובה'
              })}
              className="form-input"
              placeholder="הזן סיסמה"
              dir="ltr"
            />
            {errors.password && (
              <p className="text-red-500 text-xs mt-1">{errors.password.message}</p>
            )}
          </div>

          <div>
            <button
              type="submit"
              disabled={isLoading}
              className={`btn-primary w-full ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
            >
              {isLoading ? 'מתחבר...' : 'התחברות'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
